import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Fingerprint04 = function Fingerprint04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.8069 18.5304a4 4 0 0 1 .0544-.0891C7.2158 16.2881 7.9999 13.7418 7.9999 11c0-2.2091 1.7909-4 4-4s4 1.7909 4 4c0 1.017-.0692 2.0186-.2033 3m-2.1174 6.8436A21.9 21.9 0 0 0 15.1707 17m3.839 1.132C19.6547 15.8657 20 13.4732 20 11c0-4.4183-3.5817-8-8-8-1.4571 0-2.8233.3896-4 1.0703M3 15.364c.6407-1.3186 1-2.7994 1-4.364 0-1.4572.3896-2.8233 1.0703-4m6.9296 4c0 3.5172-1.0088 6.7988-2.7528 9.5712"
    })
  }));
};
export default Fingerprint04;